import LRUMap from 'lru-cache'

const lru = new LRUMap({
  ttlAutopurge: true,
  ttl: 20
})

export default function duration(n: number | string): string {
  if (typeof n === 'string') {
    n = Number.parseInt(n, 10)
  }

  if (isNaN(n) || n < 0) {
    return ''
  }

  // currently, the request is to display the duration in seconds if it's greater than 24 hours
  if (n >= 86400 || n === 0) {
    return `${n} seconds`
  }

  if (lru.get(n)) {
    return lru.get(n)
  }

  const plural = (condition) => (condition ? 's' : '')

  let text = ''

  // seconds
  if (n % 60 !== 0) {
    text += `${n % 60} second${plural(n % 60 !== 1)}`
  }

  if (n < 60) {
    return text
  }

  // minutes
  const minute = Math.floor(n / 60)

  if (minute >= 1 && minute <= 59) {
    // anything between the 1-59 minute range
    // prepend text to current text if it exists
    text = `${minute} minute${plural(minute !== 1)}${text && ` ${text}`}`
  } else if (minute % 60 !== 0) {
    // we don't need to display the `minute` text if the minute field is 0
    // using modulo to only get the minutes that are over an hour
    text = `${minute % 60} minute${plural(minute % 60 !== 1)}${
      text && ` ${text}`
    }`
  }

  if (n < 3600) {
    return text
  }

  // hours
  const hour = Math.floor(n / 3600)
  text = `${hour} hour${plural(hour !== 1)}${text && ` ${text}`}`

  lru.set(n, text)

  return text
}
